import * as React from 'react';
import PrivacyFull from './components/PrivacyFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var PrivacyOption = {
    key: 'search',
    titleStringKey: 'option_privacy_searchHistory',
    searchTermsStringKey: 'option_privacy_searchHistory',
    fullOptionFormSettings: {
        render: function () { return React.createElement(PrivacyFull, null); },
        hideSaveDiscard: function () { return true; },
        isDirty: function () { return false; },
        onSave: Promise.resolve,
        onDiscard: function () { },
    },
    isHidden: function () { return !isControlFeatureEnabled('sea-gdpr'); },
};
export default PrivacyOption;
//# sourceMappingURL=PrivacyOption.js.map